import { Button, Divider } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import NotificationsOffIcon from '@material-ui/icons/NotificationsOff';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import { useMutation } from '@tanstack/react-query';
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import UnloggedLayout from 'v2/components/Shared/UnloggedLayout';
import { StoreCommunicationMessageLogActionSlug, StoreCommunicationMessageLogOrigin } from 'v2/interfaces/subscriptions';
import subscriptionsService from 'v2/services/subscriptions';

import { useStyles } from './styles';

function getTypeMessage(type: string | null) {
  if (type === 'billingReminder') {
    return (
      <>
        relacionadas a <strong>lembretes de vencimento de faturas de assinatura</strong>
      </>
    );
  }
  return null;
}

export function UnsubscribeWhatsappMessage() {
  const classes = useStyles();
  const [unsubscribed, setUnsubscribed] = useState(false);
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const sentMessageId = params.get('sentMessageId');
  const type = params.get('type');
  const blacklistMessage = useMutation({
    mutationFn: (sentMessageId: string) => subscriptionsService.blacklistMessage(sentMessageId),
    onSuccess: () => {
      setUnsubscribed(true);
      storeCommunicationMessageLog.mutate(sentMessageId);
    },
    onError: (error: any) => {
      const message = error.response?.data?.data?.message || 'Erro ao processar o descadastro. Por favor, tente novamente mais tarde.';
      toast.error(message);
    },
  });
  const storeCommunicationMessageLog = useMutation({
    mutationFn: (sentMessageId: string) =>
      subscriptionsService.storeCommunicationMessageLog({
        id: sentMessageId,
        actionSlug: StoreCommunicationMessageLogActionSlug.CLICKED,
        origin: StoreCommunicationMessageLogOrigin.REDIRECT_PAGE,
        context: 'Descadastro lembrete de vencimento de fatura',
        createdAt: new Date().toISOString(),
      }),
    onError: () => {
      toast.error('Erro ao processar o descadastro. Por favor, tente novamente mais tarde.');
    },
  });

  const typeMessage = getTypeMessage(type);

  if (!sentMessageId || !typeMessage) {
    return (
      <UnloggedLayout>
        <div className={classes.container}>
          <div className={classes.content}>
            <WarningRoundedIcon className={classes.warningIcon} />
            <h2>Link inválido</h2>
            <p>Parâmetros inválidos. Por favor, verifique o link recebido.</p>
          </div>
        </div>
      </UnloggedLayout>
    );
  }

  return (
    <UnloggedLayout>
      <div className={classes.container}>
        <div className={classes.content}>
          {unsubscribed ? (
            <>
              <h2>Descadastro realizado com sucesso!</h2>
              <CheckCircleIcon className={classes.successIcon} />
              <p>Você não receberá mais mensagens {typeMessage} no WhatsApp.</p>
            </>
          ) : (
            <>
              <h2>Você está quase lá!</h2>
              <p>Ao confirmar, você deixará de receber mensagens no WhatsApp {typeMessage} do MyEduzz.</p>
              <p>Este processo é irreversível e não será possível se cadastrar novamente no futuro.</p>
              <Button
                startIcon={<NotificationsOffIcon />}
                variant='contained'
                color='primary'
                className={classes.unsubscribeButton}
                onClick={() => blacklistMessage.mutate(sentMessageId)}
                disabled={blacklistMessage.isLoading}
              >
                Confirmar descadastro
              </Button>
            </>
          )}
        </div>

        <div className={classes.footer}>
          <div className={classes.links}>
            <a href='https://www.eduzz.com/privacidade' target='_blank' rel='noopener noreferrer'>
              Política de privacidade
            </a>
            <Divider className={classes.divider} orientation='vertical' />
            <a href='https://www.eduzz.com/termos' target='_blank' rel='noopener noreferrer'>
              Termos de compra
            </a>
          </div>
        </div>
      </div>
    </UnloggedLayout>
  );
}

export default UnsubscribeWhatsappMessage;
